import Vue from 'vue';

export const state = () => ({
  leads: [],
});

export const mutations = {
  setLeads(state, slots) {
    state.leads = slots;
  },

  setLead(state, lead) {
    const index = state.leads.findIndex((l) => l.companyId == lead.companyId);

    Vue.set(state.leads, index, lead);
  },
};

export const getters = {
  all(state) {
    return state.leads;
  },
};

export const actions = {
  getLeads({ commit }, { query }) {
    const { ae, today, unqualified } = query;

    return this.$axios
      .get(`/lead?ae=${ae}&today=${today}&unqualified=${unqualified}`)
      .then((res) => {
        commit('setLeads', res.data);
      });
  },
};
